import {SystemQuaternaryCustomButton} from "../../buttons/SystemCustomButton";
import {kButtonStyles} from "../../../constants/styles";
import SystemSearchEmptyResultImage from "../../images/SystemSearchEmptyResultImage";

export default function BrevetLevelAsListVoid({clearFilters}) {
    // Used in BrevetLevelAsList to display message in case
    // of empty list of displayed LevelAs

    // BUILD
    return (
        <div className={"animate-appearSlow w-full grow overflow-auto flex justify-center items-center"}>
            <div className={"mb-[32px] w-[360px] max-w-[360px] flex flex-col justify-center items-center"}>
                <SystemSearchEmptyResultImage />
                <span className={"text-greyLight7 text-center"}>
                {"Oops, je n'ai trouvé aucun savoir-faire qui correspond à ta recherche"}
            </span>
                <SystemQuaternaryCustomButton
                    label={"Réinitialiser les filtres"}
                    isDisabled={false}
                    isLoading={false}
                    isFullWidth={false}
                    sizeStyle={kButtonStyles.smallButtonStyle}
                    onButtonClick={clearFilters}
                    extraClass={"mt-[24px]"} />
            </div>
        </div>
    );
}